export type MenuAccess = {
  dashboard: boolean;
  userManagement: boolean;
  contractorManagement: boolean;
  generalContractorManagement: boolean;
  jobsiteManagement: boolean;
  reports: boolean;
  settings: boolean;
  jobsiteVisits: boolean;
};

export type DashboardAccess = {
  blitzMode: boolean;
};

export type JobsiteManagementAccess = {
  addJobsite: boolean;
  deleteJobsite: boolean;
  restoreJobsite: boolean;
};

export type ContractorManagementAccess = {
  addContractor: boolean;
  editContractor: boolean;
};

export type GeneralContractorManagementAccess = {
  addGeneralContractor: boolean;
  editGeneralContractor: boolean;
};

export type JobsiteVisitsAccess = {
  addJobsiteVisit: boolean;
  deleteJobsiteVisit: boolean;
}

export const roleAccessConfig: Record<string, {
  menu: MenuAccess;
  dashboard: DashboardAccess;
  jobsiteManagement: JobsiteManagementAccess;
  contractorManagement: ContractorManagementAccess;
  generalContractorManagement: GeneralContractorManagementAccess;
  jobsiteVisits: JobsiteVisitsAccess;
}> = {
  admin: {
    menu: {
      dashboard: true,
      userManagement: true,
      jobsiteManagement: true,
      contractorManagement: true,
      generalContractorManagement: true,
      jobsiteVisits: true,
      reports: true,
      settings: true,
    },
    dashboard: {
      blitzMode: true,
    },
    jobsiteManagement: {
      addJobsite: true,
      deleteJobsite: true,
      restoreJobsite: true,
    },
    contractorManagement: {
      addContractor: true,
      editContractor: true,
    },
    generalContractorManagement: {
      addGeneralContractor: true,
      editGeneralContractor: true,
    },
    jobsiteVisits: {
      addJobsiteVisit: true,
      deleteJobsiteVisit: true,
    }
  },
  organizer: {
    menu: {
      dashboard: false,
      userManagement: false,
      jobsiteManagement: true,
      contractorManagement: true,
      generalContractorManagement: true,
      jobsiteVisits: true,
      reports: true,
      settings: true,
    },
    dashboard: {
      blitzMode: false,
    },
    jobsiteManagement: {
      addJobsite: true,
      deleteJobsite: false,
      restoreJobsite: false,
    },
    contractorManagement: {
      addContractor: true,
      editContractor: true,
    },
    generalContractorManagement: {
      addGeneralContractor: true,
      editGeneralContractor: true,
    },
    jobsiteVisits: {
      addJobsiteVisit: true,
      deleteJobsiteVisit: false,
    }
  },
  interrepre: {
    menu: {
      dashboard: true,
      userManagement: false,
      jobsiteManagement: true,
      contractorManagement: true,
      generalContractorManagement: true,
      jobsiteVisits: true,
      reports: true,
      settings: true,
    },
    dashboard: {
      blitzMode: false,
    },
    jobsiteManagement: {
      addJobsite: false,
      deleteJobsite: false,
      restoreJobsite: false,
    },
    contractorManagement: {
      addContractor: false,
      editContractor: false,
    },
    generalContractorManagement: {
      addGeneralContractor: false,
      editGeneralContractor: false,
    },
    jobsiteVisits: {
      addJobsiteVisit: false,
      deleteJobsiteVisit: false,
    }
  },
};

export const getMenuAccess = (role: string): MenuAccess => {
  return roleAccessConfig[role.toLowerCase()]?.menu || {
    dashboard: false,
    jobsiteVisits: false,
    userManagement: false,
    contractorManagement: false,
    generalContractorManagement: false,
    jobsiteManagement: false,
    reports: false,
    settings: false,
  };
};

export const getDashboardAccess = (role: string): DashboardAccess => {
  return roleAccessConfig[role.toLowerCase()]?.dashboard || {
    blitzMode: false,
  };
};

export const getJobsiteManagementAccess = (role: string): JobsiteManagementAccess => {
  return roleAccessConfig[role.toLowerCase()]?.jobsiteManagement || {
    addJobsite: false,
    deleteJobsite: false,
  };
};

export const getContractorManagementAccess = (role: string): ContractorManagementAccess => {
  return roleAccessConfig[role.toLowerCase()]?.contractorManagement || {
    addContractor: false,
    editContractor: false,
  };
};

export const getGeneralContractorManagementAccess = (role: string): GeneralContractorManagementAccess => {
  return roleAccessConfig[role.toLowerCase()]?.generalContractorManagement || {
    addGeneralContractor: false,
    editGeneralContractor: false,
  };
};